const faFrame = {
  prefix: 'fal',
  iconName: 'frame',
  icon: [
    512,
    512,
    [],
    'e495',
    'M512 80c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-320 0 0-48C96 7.2 88.8 0 80 0S64 7.2 64 16l0 48-48 0C7.2 64 0 71.2 0 80S7.2 96 16 96l48 0 0 320-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 320 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-320 48 0c8.8 0 16-7.2 16-16zM416 96l0 320-320 0 0-320 320 0z',
  ],
};
export default faFrame;
